import React from 'react';
import { IndexRoute, Route } from 'react-router';

import App from '../App';

import AboutUs from '../pages/AboutUs';
import Companies from '../pages/Companies';
import Contact from '../pages/Contact';
import Home from '../pages/Home';
import NotFound from '../pages/errors/NotFound';
import Portfolio from '../pages/Portfolio';
import Universities from '../pages/Universities';

module.exports = (
    <Route path="/" component={App}>
        <IndexRoute component={Home} />

        <Route path="/aboutus" component={AboutUs} />
        <Route path="/companies" component={Companies} />
        <Route path="/contact" component={Contact} />
        <Route path="/portfolio" component={Portfolio} />
        <Route path="/universities" component={Universities} />

        <Route path="*" component={NotFound}/>
    </Route>
);



// WEBPACK FOOTER //
// ./src/system/routes.js